





































import Vue, { PropType } from "vue";
import Attribute from "@/components/molecules/Attribute.vue";
import ButtonRound from "@/components/atoms/ButtonRound.vue";
import ImageView from "@/components/atoms/ImageView.vue";
import { WorldView } from "@/lib/models";

export default Vue.extend<Data, Methods, Computed, Props>({
  components: {
    Attribute,
    ButtonRound,
    ImageView,
  },
  props: {
    novelId: String,
    worldView: Object as PropType<WorldView>,
  },
  computed: {
    detail() {
      const { detail } = this.worldView as WorldView;
      return Object.assign(
        {},
        ...detail.map((d) => ({
          [d.name]: d.value,
        }))
      );
    },
    additionalColumn() {
      return this.worldView.additionalColumn;
    },
    getWorldViewKey() {
      const {
        novelId,
        worldView: { worldViewId, image },
      } = this;
      if (image && image.startsWith("file:")) {
        return `file:novels/${novelId}/worldviews/${worldViewId}.jpg`;
      }
      return image;
    },
  },
});

interface Props {
  novelId: string;
  worldView: WorldView;
}

interface Data {}

interface Computed {
  detail: { [key: string]: string };
  additionalColumn: { name: string; label: string; content: string };
  getWorldViewKey: string;
}

interface Methods {}
